export default "__VITE_ASSET__DEu_wMu___"